import { Injectable } from '@angular/core';
import { SICOM_PATHS } from 'src/sicom-paths';
import { AbstractReportJobService } from '@/core/services/report-job/abstract-report-job.service';
import { JobStatus, ReportJob } from '@/core/services/report-job/report-job.model';

/** Alias de compatibilidade (mesma convenção dos demais relatórios de médico). */
export type CertidaoFinsInternacionaisMedicoJob = ReportJob;
export type CertidaoFinsInternacionaisMedicoJobStatus = JobStatus;

/** Job service (polling/sessionStorage/download) da Certidão para Fins Internacionais (Médico). */
@Injectable({ providedIn: 'root' })
export class CertidaoFinsInternacionaisMedicoJobService extends AbstractReportJobService {
    protected readonly sessionKey = 'certidao-fins-internacionais-medico-jobId';
    protected readonly baseUrl = SICOM_PATHS.registro.medico.reports.certidaoFinsInternacionaisMedico;
}
